/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from 'react';
import {
  DataAPIClientError,
  UpdateMessageTemplateParameters
} from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';

interface State {
  data?: string;
  error?: DataAPIClientError;
  isProcessing: boolean;
}

interface Result extends State {
  invoke: (templateID: string, params: UpdateMessageTemplateParameters) => void;
}

export default function useDataAPIUpdateMessageTemplate(): Result {
  const client = useDataAPIClient();

  const [state, setState] = useState<State>({ isProcessing: false });

  async function invoke(
    templateID: string,
    params: UpdateMessageTemplateParameters
  ): Promise<void> {
    setState({ isProcessing: true });

    try {
      const data = await client.updateMessageTemplate(templateID, params);

      setState({ data, isProcessing: false });
    } catch (error: any) {
      setState({ error, isProcessing: false });
    }
  }

  return { ...state, invoke };
}
